import { getFloorPlan } from './getFloorPlan';
import { getLayout } from './getLayout';
import { getPhotos } from './getPhotos';
import { IState } from '../../store';
import { ITabs } from '../../types/newbuildingTiledCarousel';

export const getNewbuildingTiledCarouselTabs = (state: IState): ITabs[] => {
  const photos = getPhotos(state);
  const isLayout = !!getLayout(state);
  const isFloorPlan = !!getFloorPlan(state);

  const tabs = [];

  if (isLayout) {
    tabs.push({
      value: 1,
      title: 'Планировка',
      type: 'layout' as const,
    });
  }

  if (isFloorPlan) {
    tabs.push({
      value: 1 + Number(isLayout),
      title: 'План этажа',
      type: 'floorplan' as const,
    });
  }

  if (photos.length) {
    tabs.push({
      value: 1 + Number(isLayout) + Number(isFloorPlan),
      title: 'Галерея комплекса',
      type: 'gallery' as const,
    });
  }

  return tabs;
};
